var _rect, _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPremium(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 4,
    fill: "#FFC741"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.3096 5C16.853 5.0001 17.3532 5.29681 17.6143 5.77344L19.5098 9.2334C19.8215 9.80275 19.7275 10.5088 19.2783 10.9775L12.6826 17.8604C12.2265 18.3363 11.4659 18.3363 11.0098 17.8604L4.41408 10.9775C3.96488 10.5088 3.87086 9.80276 4.18263 9.2334L6.07814 5.77344C6.3392 5.29676 6.83939 5.00007 7.38283 5H16.3096ZM7.38283 6C7.20468 6.00007 7.04064 6.0977 6.95509 6.25391L5.05959 9.71387C4.95752 9.90047 4.98868 10.1316 5.13576 10.2852L11.7315 17.168C11.7939 17.2331 11.8985 17.2331 11.961 17.168L18.5567 10.2852C18.7038 10.1315 18.7341 9.90049 18.6319 9.71387L16.7373 6.25391C16.6518 6.09769 16.4876 6.0001 16.3096 6H7.38283Z",
    fill: "#121212"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.1653 5.01416C10.4336 5.07927 10.5985 5.35032 10.5334 5.61865L9.50415 9.86572C9.46502 10.0272 9.4755 10.1969 9.5354 10.352L12.303 17.5171C12.3307 17.5792 12.3469 17.6478 12.3469 17.7202C12.3469 17.9963 12.123 18.2201 11.8469 18.2202H11.845C11.6385 18.2201 11.4536 18.0925 11.3791 17.8999L8.60278 10.7124C8.46948 10.3672 8.44423 9.98917 8.53149 9.62939L9.56176 5.38232C9.62701 5.11422 9.89706 4.94914 10.1653 5.01416Z",
    fill: "#121212"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5273 5.01416C13.7956 4.94915 14.0656 5.1142 14.1309 5.38232L15.1602 9.62939C15.2365 9.94411 15.2276 10.273 15.1348 10.5815L15.0898 10.7124L12.3135 17.8999C12.239 18.0927 12.0533 18.2202 11.8467 18.2202H11.8457C11.5696 18.2202 11.3457 17.9963 11.3457 17.7202C11.3457 17.6475 11.3617 17.5785 11.3896 17.5161L14.1572 10.352C14.2171 10.197 14.2276 10.0273 14.1885 9.86572L13.1592 5.61865C13.0941 5.35028 13.259 5.07921 13.5273 5.01416Z",
    fill: "#121212"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M19.1787 9.60938C19.4548 9.60942 19.6787 9.83326 19.6787 10.1094C19.6787 10.3855 19.4548 10.6093 19.1787 10.6094H4.5127C4.23655 10.6094 4.0127 10.3855 4.0127 10.1094C4.0127 9.83323 4.23655 9.60938 4.5127 9.60938H19.1787Z",
    fill: "#121212"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPremium);
export default __webpack_public_path__ + "static/media/premium.4e6682623bcdc934cf6a9846f0f87d46.svg";
export { ForwardRef as ReactComponent };